// Greedy nearest-neighbor drop ordering from the pickup point.
// Returns an array of original stop indexes in suggested order, or null if
// the current order is already optimal / there are fewer than 2 drops.
export function suggestOrder(points) {
  if (!points || points.length < 3) return null; // needs pickup + 2+ stops
  const toRad = (d) => (d * Math.PI) / 180;
  const dist = (a, b) => {
    const dLat = toRad(b.lat - a.lat);
    const dLon = toRad(b.lon - a.lon);
    const h =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLon / 2) ** 2;
    return 2 * 3958.8 * Math.asin(Math.sqrt(h));
  };
  const drops = points.slice(1).map((p, i) => ({ ...p, origIndex: i }));
  let cur = points[0];
  const order = [];
  const remaining = [...drops];
  while (remaining.length) {
    remaining.sort((a, b) => dist(cur, a) - dist(cur, b));
    const next = remaining.shift();
    order.push(next.origIndex);
    cur = next;
  }
  const isSame = order.every((idx, i) => idx === i);
  return isSame ? null : order;
}
